<template>
  <div class="all">
    <!-- <Header></Header> -->
    <div class="recommend">Recommendation for you!</div>
    <div class="basedOn">
        Based on your answers and our medical advisory board’s suggestion, here are your personalized recommendations for only!
    </div>
    <button @click="toProd">Start Reading</button>
  </div>
</template>

<script>

export default {
  components: {
   
  },
  methods: {
    toProd () {
      this.$sensors.track('ClickStartReading', {}, 
      ()=>{
        this.$router.push('/report/product')
      })
    },
  }
}
</script>

<style scoped lang="less">
.all {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .recommend {
    width: 204.5px;
    text-align: center;
    padding-top: 173px;
    padding-bottom: 38px;
    height: 276px;
    font-size: 24px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #000000;
    line-height: 29px;
  }
  .basedOn {
    width: 305px;
    height: 195px;
    font-size: 20px;
    font-family: Helvetica;
    color: #000000;
    line-height: 27px;
    text-align: center;
  }
  button {
    // width: 120.5px;
    // height: 26px;
    font-size: 17px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 20.5px;
    width: 225px;
    height: 45px;
    background: #E26CA5;
    border-radius: 36px;
    border: none;
    margin-top: 33.5px;
  }
}
@media only screen and (min-width: 767px) {
  .all {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .recommend {
    width: 437px;
    // padding-top: 332px;
    padding-bottom: 64px;
    // height: 514px;
    height: 327px;
    // height: 180px!important;
    font-size: 48px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #000000;
    line-height: 58px;
  }
  .basedOn {
    width: 900px;
    height: 218px;
    padding-bottom: 138px;
    font-size: 30px;
    font-family: Helvetica;
    color: #000000;
    line-height: 40px;
    text-align: center;
  }
  button {
    width: 350px;
    height: 70px;
    padding: 0px;
    margin: 0px;
    background: #E26CA5;
    border-radius: 72px;
    font-size: 26px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 31px;
  }
}
}
</style>